import React from 'react';
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const sectionLabelSx = {
  fontSize: '0.75rem',
  fontWeight: 700,
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  mb: 0.5,
};

const sectionValueSx = {
  fontSize: '0.9375rem',
  fontWeight: 600,
  color: 'text.primary',
  lineHeight: 1.5,
};

const CommunityMemberProfileDialog = ({
  open,
  member,
  onClose,
  showInterests = true,
  showPhoneNumber = false,
}) => {
  const interests = Array.isArray(member?.interests) ? member.interests.filter(Boolean) : [];

  const getGenderLabel = (gender) => {
    if (gender === 'male') return 'Male';
    if (gender === 'female') return 'Female';
    if (gender === 'other') return 'Other';
    return '—';
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
          fontWeight: 700,
        }}
      >
        Member Profile
        <IconButton aria-label="Close member profile" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2 }}>
        {member ? (
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Avatar src={member.avatarUrl || undefined} alt={member.fullName || 'Member'} />
              <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
                {member.fullName || 'Member'}
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Box sx={{ mb: 1.5 }}>
              <Typography sx={sectionLabelSx}>Email</Typography>
              <Typography sx={sectionValueSx}>{member.userEmail || '—'}</Typography>
            </Box>

            {showPhoneNumber ? (
              <Box sx={{ mb: 1.5 }}>
                <Typography sx={sectionLabelSx}>Phone</Typography>
                <Typography sx={sectionValueSx}>{member.phoneNumber || '—'}</Typography>
              </Box>
            ) : null}

            <Box sx={{ mb: 1.5 }}>
              <Typography sx={sectionLabelSx}>Profession</Typography>
              <Typography sx={sectionValueSx}>{member.profession || '—'}</Typography>
            </Box>

            <Box sx={{ mb: showInterests ? 1.5 : 0 }}>
              <Typography sx={sectionLabelSx}>Gender</Typography>
              <Typography sx={sectionValueSx}>{getGenderLabel(member.gender) || '—'}</Typography>
            </Box>

            {showInterests ? (
              <Box>
                <Typography sx={sectionLabelSx}>Interests</Typography>
                {interests.length ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                    {interests.map((interest) => (
                      <Chip
                        key={interest}
                        label={interest}
                        size="small"
                        sx={{ fontWeight: 600, bgcolor: 'action.hover', color: 'text.primary' }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography sx={sectionValueSx}>—</Typography>
                )}
              </Box>
            ) : null}
          </Box>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default CommunityMemberProfileDialog;
